import * as React from 'react'
import { useCustomerApi } from './useCustomerApi'
import { useCustomers } from './useCustomers'
import { useLogger } from './useLogger'

const HEALTH_STATUS_INTERVAL = 30 * 1000 // 30 seconds

export const useAllCustomersHealthSync = () => {
  const { logError } = useLogger()
  const { getHealthInfoForAllCustomerAgencies } = useCustomerApi()
  const { lastApiReceiveAt, dispatch: dispatchCustomerAction } = useCustomers()

  // set up timers to sync the connector health info
  React.useEffect(() => {
    const syncHealthInfo = () => {
      getHealthInfoForAllCustomerAgencies()
        .then(response => {
          if (response === null) return

          if (response.status === 200) {
            dispatchCustomerAction({
              type: 'SetCustomerAgencyInterfaceHealthStatuses',
              payload: response.data,
            })
          }
        })
        .catch(error => {
          logError(error)
        })
    }

    syncHealthInfo()

    const interval = setInterval(() => {
      syncHealthInfo()
    }, HEALTH_STATUS_INTERVAL)

    return () => {
      clearInterval(interval)
    }
  }, [lastApiReceiveAt])
}
